import GenerateReportButton from "../../components/GenerateReports/GenerateReport";
import NavBar from "../../components/Navbar/Navbar";

function ReportGenerationPage() {
    return(
        <section className="ReportGeneration">
            <NavBar />
            <GenerateReportButton />
        </section>
    )
}

export default ReportGenerationPage